import React, { useState, useEffect } from "react";
import "bootstrap/dist/css/bootstrap.min.css";

export default function StepTwoForm({ onNext, onBack, initialData }) {
  const [formData, setFormData] = useState({
    company_position: "",
    helpNeeded: "",
    budget: "",
  });

  // Prefill form if initialData exists
  useEffect(() => {
    if (initialData) {
      setFormData(prev => ({
        ...prev,
        company_position: initialData.company_position || "",
        helpNeeded: initialData.helpNeeded || "",
        budget: initialData.budget || "",
      }));
    }
  }, [initialData]);

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value,
    });
  };

  const handleSubmit = (e) => {
    e.preventDefault();

    console.log("Step 2 data:", formData); // Debug log

    if (!formData.company_position || !formData.helpNeeded || !formData.budget) {
      alert("Please fill in all fields.");
      return;
    }

    onNext(formData); // Pass data to MultiStepForm
  };

  return (
    <div className="d-flex justify-content-center align-items-center min-vh-100" style={{ background: "#ffffffff" }}>
      <div
        className="card border-0 shadow-lg"
        style={{
          maxWidth: "650px",
          width: "100%",
          borderRadius: "2rem",
          overflow: "hidden",
          background: "rgba(255, 255, 255, 0.95)",
          backdropFilter: "blur(12px)",
          animation: "fadeIn 0.7s ease-in-out",
        }}
      >
        <h3
          className="text-center fw-bold mb-0 text-white"
          style={{ background: "#009494", padding: "2.5rem", fontSize: "1.8rem" }}
        >
          Step 2: What's your business about?
        </h3>

        <div style={{ padding: "2.5rem" }}>
          <form onSubmit={handleSubmit}>
            <div className="mb-4">
              <label className="form-label fw-semibold">What is your company position?</label>
              <select
                value={formData.company_position}
                onChange={handleChange}
                required
                className="form-control"
                name="company_position"
              >
                <option value="">(Choose one)</option>
                <option value="Founder / Co-Founder">Founder / Co-Founder</option>
                <option value="CEO / Managing Director">CEO / Managing Director</option>
                <option value="Marketing Manager">Marketing Manager</option>
                <option value="Operations Manager">Operations Manager</option>
                <option value="IT / Technical Lead">IT / Technical Lead</option>
                <option value="Business Owner">Business Owner</option>
                <option value="Freelancer / Independent Professional">Freelancer / Independent Professional</option>
                <option value="Other">Other</option>
              </select>
            </div>

            <div className="mb-4">
              <label className="form-label fw-semibold">How are we going to help your business?</label>
              <select
                value={formData.helpNeeded}
                onChange={handleChange}
                required
                className="form-control"
                name="helpNeeded"
              >
                <option value="">(Select what fits best)</option>
                <option value="Build a brand new website from scratch">Build a brand new website from scratch</option>
                <option value="Redesign or modernize an existing website">Redesign or modernize an existing website</option>
                <option value="Develop an e-commerce platform">Develop an e-commerce platform</option>
                <option value="Improve website speed and performance">Improve website speed and performance</option>
                <option value="Integrate online booking, payments, or CRM tools">Integrate online booking, payments, or CRM tools</option>
                <option value="Provide ongoing website maintenance and updates">Provide ongoing website maintenance and updates</option>
                <option value="Other">Other</option>
              </select>
            </div>

            <div className="mb-5">
              <label className="form-label fw-semibold">How much are you ready to invest?</label>
              <select
                value={formData.budget}
                onChange={handleChange}
                required
                className="form-control"
                name="budget"
              >
                <option value="">(Indicative budget ranges)</option>
                <option value="₱10,000 – ₱25,000 (basic website or portfolio)">₱10,000 – ₱25,000 (basic website or portfolio)</option>
                <option value="₱25,000 – ₱50,000 (standard business site with multiple pages)">₱25,000 – ₱50,000 (standard business site with multiple pages)</option>
                <option value="₱50,000 – ₱100,000 (custom design + integrations)">₱50,000 – ₱100,000 (custom design + integrations)</option>
                <option value="₱100,000+ (enterprise, e-commerce, or large project)">₱100,000+ (enterprise, e-commerce, or large project)</option>
                <option value="Not sure yet / Need a quote">Not sure yet / Need a quote</option>
              </select>
            </div>

            <div className="d-flex gap-3">
              <button
                type="button"
                onClick={onBack}
                className="btn w-100 py-3 fw-semibold"
                style={{
                  background: "#e2e2e2ff",
                  color: "#3b3b3bff",
                  borderRadius: "0.7rem",
                  letterSpacing: "0.5px",
                  boxShadow: "0 4px 10px rgba(68, 68, 68, 0.3)",
                  transition: "transform 0.2s ease-in-out, box-shadow 0.2s",
                }}
              >
                ← Back
              </button>

              <button
                type="submit"
                className="btn w-100 py-3 fw-semibold"
                style={{
                  background: "#009494",
                  color: "white",
                  borderRadius: "0.7rem",
                  letterSpacing: "0.5px",
                  boxShadow: "0 5px 15px rgba(0, 148, 148, 0.3)",
                  transition: "transform 0.2s ease-in-out, box-shadow 0.2s",
                }}
              >
                Next →
              </button>
            </div>
          </form>
        </div>
      </div>

      <style>{`
        @keyframes fadeIn {
          from { opacity: 0; transform: translateY(15px); }
          to { opacity: 1; transform: translateY(0); }
        }
  .form-control {
    font-size: 1.5rem !important;
  }
      `}</style>
    </div>
  );
}
